/** @file nodeAngles: a node's azimuth under the camera and its pitch, from the PoseBuffer read-back columns. */
import type { PoseBuffer } from '@zilo/pose3d-pose/contract';
import { POSE_LAYOUT } from '@zilo/pose3d-pose/layout/poseLayout';
import { wrapDegrees } from '@zilo/pose3d-std/math/wrapDegrees';

/**
 * `azimuthDeg = wrapDegrees(yaw column + cameraYawDeg)`, `pitchDeg` = the pitch column, (-180, 180] and unfolded (21.1;
 * facing and rest are already in the columns, decision 1; body facing is never added). Writes `out` and returns it.
 */
export function nodeAngles(pose: PoseBuffer, nodeIndex: number, cameraYawDeg: number,
  out: { azimuthDeg: number; pitchDeg: number }): typeof out {
  const o = nodeIndex * POSE_LAYOUT.stride;
  out.azimuthDeg = wrapDegrees((pose[o + POSE_LAYOUT.yaw] ?? 0) + cameraYawDeg);
  out.pitchDeg = pose[o + POSE_LAYOUT.pitch] ?? 0;
  return out;
}
